/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-12 14:46:12
 * @LastEditTime: 2022-01-12 15:53:41
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 银联分账系统对账单 
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/YLSharingPayOrderSummaryList/index.jsx
 */


import React, { useRef } from 'react'
import TableHelper from '../../../components/TableHelper'
import { fetchPlatformRecordYlSharingPayOrderSummaryList } from '../../../services/platformAccountingRecord'
import { formatTime } from '../../../utils'
import YLSharingPayOrderSummaryDataOrderList from "./components/YLSharingPayOrderSummaryDataOrderListModal";

const YLSharingPayOrderSummaryList = (props) => {
    let YLSharingPayOrderSummaryDataOrderListRef = useRef()

    const handleOpen = (id) => {
        console.log(YLSharingPayOrderSummaryDataOrderListRef.open)
        YLSharingPayOrderSummaryDataOrderListRef.open(id)
    }
    const columns = [
        { title: '商户集团编号', dataIndex: 'merchantGroupNumber', },
        { title: '对账文件名称', dataIndex: 'fileName', render: (text, record) => {
            return <a href={record.fileUrl} download target="view_frame">{text}</a>
        } },
        { title: '交易笔数', dataIndex: 'tradeNum'},
        { title: '交易金额', dataIndex: 'tradeAmount', },
        { title: '手续费', dataIndex: 'serviceCharge', },
        { title: '交易净额', dataIndex: 'tradeNetAmount', },
        { title: '可划付金额', dataIndex: 'transferableAmount', },
        { title: '划付中金额', dataIndex: 'transferInProgressAmount', },
        { title: '已划付金额', dataIndex: 'transferredAmount', },
        { title: '创建时间', dataIndex: 'createTime', render: formatTime },
        { title: '操作', dataIndex: 'action', render: (text, record) => {
            return <a onClick={() => handleOpen(record.id) }>详情</a>
        } },
    ]
    const searchOptions = [
        { key: 'startDate', type: 'date', placeholder: '开始日期' },
        { key: 'endDate', type: 'date', placeholder: '结束日期' },
    ]
    return (
        <div>
            <TableHelper 
                columns={columns} 
                searchOptions={searchOptions}
                request={fetchPlatformRecordYlSharingPayOrderSummaryList} 
            />
            <YLSharingPayOrderSummaryDataOrderList getRef={ref => YLSharingPayOrderSummaryDataOrderListRef = ref } />
        </div>
    )
}

export default YLSharingPayOrderSummaryList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/YLSharingPayOrderSummaryList/index.jsx